import React, { useEffect, useRef, useState } from 'react';
import { Modal, Image, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { getCustomerMediaBlobUrl } from '../../services/workspaceMediaService';

const { Text } = Typography;

const isImageExt = (ext) =>
  ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(String(ext || '').toLowerCase());

const WorkspaceMediaPreviewModal = ({ open, media, onClose }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const blobUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const revokeCurrent = () => {
      const u = blobUrlRef.current;
      if (u && u.startsWith('blob:')) {
        window.URL.revokeObjectURL(u);
      }
      blobUrlRef.current = null;
    };

    const run = async () => {
      revokeCurrent();
      setBlobUrl(null);
      if (!open || !media?.id) {
        setLoading(false);
        return;
      }
      if (!isImageExt(media.extension)) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const url = await getCustomerMediaBlobUrl(media.id);
      if (cancelled) {
        if (url && url.startsWith('blob:')) {
          window.URL.revokeObjectURL(url);
        }
        return;
      }
      blobUrlRef.current = url;
      setBlobUrl(url);
      setLoading(false);
    };
    run();
    return () => {
      cancelled = true;
      revokeCurrent();
      setBlobUrl(null);
    };
  }, [open, media?.id, media?.extension]);

  if (!media) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      title={media.display_name}
      destroyOnClose
    >
      {isImageExt(media.extension) ? (
        <div style={{ textAlign: 'center', minHeight: 200 }}>
          {loading ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : blobUrl ? (
            <Image src={blobUrl} alt={media.display_name} style={{ maxWidth: '100%' }} />
          ) : (
            <Text type="secondary">Preview unavailable</Text>
          )}
        </div>
      ) : (
        <Text type="secondary">Preview is not available for this file type. Use Download from the list.</Text>
      )}
    </Modal>
  );
};

export default WorkspaceMediaPreviewModal;
